// Compact ₪ formatting for budget chips/labels.
// Sale amounts collapse to millions with up to 2 decimals when relevant
// (₪1.5M, ₪1.25M, ₪2M); sub-million to thousands (₪850K). Rent amounts stay
// as full numbers with separators (₪6,500).
const trimZeros = (s: string): string => s.replace(/\.?0+$/, "");

export const formatBudgetShort = (n: number, rent = false): string => {
  if (rent) return `₪${n.toLocaleString("en-US")}`;
  if (n >= 1_000_000) return `₪${trimZeros((n / 1_000_000).toFixed(2))}M`;
  return `₪${trimZeros((n / 1_000).toFixed(1))}K`;
};

// Range label ordered correctly for RTL display: the MIN must appear on the
// RIGHT (the reading-direction start). Without the RLM marks the two ₪-number
// runs and the dash between them collapse into ONE left-to-right bidi run, so
// the range renders min-on-the-left even inside an RTL page. The RLMs make the
// dash inherit the RTL context, which places the first (min) run rightmost.
// NOTE: the marks around the dash are LITERAL invisible U+200F characters.
export const formatBudgetRangeShortRtl = (min: number, max: number, rent = false): string =>
  `${formatBudgetShort(min, rent)}‏–‏${formatBudgetShort(max, rent)}`;
